<template>
  <section class="purchasedServices">
    <header-com class='bgw'/>
    <tabCom :tabData="navData"
    :activeIndex="activeIndex"
    @changeTab='changeTab'
    class='top'
    />
    <ul v-if='servicesList.length != 0'>
   
      <li v-for="(item, index) in servicesList" :key="index"
          :style="{'backgroundImage':'url(/images/my/' + getItem(item)+'.png)'}" @click='toDetail(item)'>
        <div class="inner">
          <h2 class="bold" :class='{activecolor:activeIndex != 1}'>
            <span class="f28 fw500">{{item.curingServiceName}}</span>
          </h2>
          <div style='color:#333333' :class='{activecolor:activeIndex != 1}'>
            <span class="f24 fw500">￥{{item.curingServicePrice}}</span>
            <span>x{{item.quantity}}</span>
          </div>
          
          <div class='time_content'>
            <time style='color:#999'>{{item.createTime}}</time>
            <span class="meituan" v-if='activeIndex == 0 && item.source==20'>团购</span>
            <button class="primary" size="mini" v-if='activeIndex == 1 && item.classify == 10' @click.stop='applyConcel(item)'>申请退款</button>
            <button class="primary refundBtn" size="mini" v-if='activeIndex == 2' @click.stop='refundState(item)'>退款进度</button>
          </div>
        </div>
      </li>
    </ul>

    <div v-else>
      <img src='/images/base/no_list_copunt.png' class='no-list'>

    </div>

    <!-- 取消订单弹窗 -->
    <van-popup position="bottom" v-model="concelShow">
      <div class="containers f28">
        <div class="title">请选择申请退款的原因（必选）</div>
        <div class="close" @click="concelShow = false"></div>
        <ul>
          <li v-for='(item,index) in concelList' :key='index' @click='concelReason = item.key'>
            <div><radio @changeRadio='concelReason = item.key' :checked="concelReason == item.key"/></div>
            <span>{{item.value}}</span>
          </li>
        </ul>
        <button class="submit btn-black-round" :disabled='!concelReason' @click='concelSubmit'>提交</button>
      </div>
    </van-popup>

    <van-popup position="bottom" v-model="refundShow">
      <div class='containerRefond f28 content'>
        <div class="title">退款进度</div>
        <div class="close" @click="refundShow = false"></div>
        <ul>
          <li v-for='(item,index) in refundLog' class='refundLi' :class='{lastRefund:index == refundLog.length -1}'><img src='/images/my/circle.png' class='circle' v-if='index != refundLog.length -1'><img v-else src='/images/my/dcircle.png' class='dcircle'>
            {{item.statusText}}
            <time>{{item.createTime}}</time>
          </li>
        </ul>
      </div>
    </van-popup>
  </section>
</template>

<script>
  import myApi from '@/axios/my'
  import orderApi from '@/axios/order'
  import { Toast,Dialog } from 'vant';
  import zhugeObj from '@/assets/js/track';
  export default {
    name: 'purchasedServices',
    data () {
      return {
        refundShow : false,
        loading: true,
        finished : false,
        loadMore : true,
        concelId : {},
        concelShow : false,
        concelList : [],
        concelReason : '',
        activeIndex : 0,
        navData: [
          {
            name: '已使用',
            type: 0
          },
          {
            name: '未使用',
            type: 1
          },
          {
            name: '退款',
            type: 2
          }
        ],
        servicesList: [

        ],
        usedServicesList:[],
        nousedServicesList : [],
        servicesListRefound : [],
        servicesObj : {},
        pageCont : {
          current : 1,
          size	 : 10
        },
        refundLog : []
      }
    },
    watch: {},
    computed: {},
    created () {
      this.customerCuringService(1);
      this.customerCuringServiceRefound();
      this.getReasonList();
    },
    mounted () {
      
    },
    methods: {
      refundState(item){

        zhugeObj.track({
          title : '已购服务',
          content : {
            '退款进度' : '查看进度'
          }
        })
        this.refundShow = true;
        this.refundLog = item.refundLogList;
        
      },
      toDetail(item){
        let obj = {
          createTime : item.createTime,
          name : item.curingServiceName,
          quantity : item.quantity,
          cardprice:item.curingServicePrice,
          priceText : item.curingServicePrice*item.quantity,
          discountPrice : item.discountPrice,
          curingServiceRealPrice : item.curingServiceRealPrice*item.quantity,
          categoryName : item.categoryName
        }
        this.$router.push({name:'purchaseDetail',query:{detail:JSON.stringify(obj)}})
      },
      concelSubmit(){
       
        this.submitRetun();

      },
      submitRetun(){
        let params = {
          id : this.concelId.id,
          quantity : this.concelId.quantity,
          refundReasonId : this.concelReason
        }
        zhugeObj.track({
          title : '已购服务',
          content : {
            '申请退款' : '申请退款',
            '退款服务项' : this.concelId.curingServiceName,
            '退款原因' : this.concelReason,
          }
        })
        myApi.concelCuringService(params).then((res)=>{

          this.concelShow = false;
          Toast('取消成功');
          this.customerCuringService(0);
          this.customerCuringServiceRefound();
        })
      },
      applyConcel(id){
        if(id.operationType == 31){
          Dialog.confirm({
            title: '提示',
            message: '客返服务项不允许退款。',
            cancelButtonText : '知道了',
            showConfirmButton : false,
            messageAlign : 'center'
          }).then(() => {
  
            
          })
          return;
        }
       

        this.concelId = id;
        this.concelShow =  true;
      },
      getReasonList(){
        orderApi.getCancelReason({}).then((res)=>{
          this.concelList = res;
        })
      },
      changeTab(index){
        this.activeIndex = index;
        this.servicesList = [];
        if(this.activeIndex == 0){
          this.servicesList = this.usedServicesList;

        }else if(this.activeIndex == 1){
        
          if(this.nousedServicesList.length == 0){
            this.customerCuringService(0);
          }else{
            this.servicesList = this.nousedServicesList;
          }
        }else{
          this.servicesList = this.servicesListRefound
        }
      },
      customerCuringServiceRefound(){
        myApi.customerCuringServiceRefound({}).then((res)=>{
          this.servicesListRefound = res;
          if(this.activeIndex == 2){
            this.servicesList = res;
          }
        })
      },
      customerCuringService(used){
        this.loading = true;
        let params = {
          used : used
        }
        myApi.customerCuringService(params).then((res)=>{
          if(used){
            this.usedServicesList = res;
            this.servicesList = res;
          }else{
            this.nousedServicesList = res;
            this.servicesList = res;
            console.log(this.servicesList)
          }
          
          this.loading = false;
        })
      },
      changeUseType(item){
        let name = item.categoryName;
        if(!name){
          return 0;
        }

        if(name.match('包')){
          return 0;
        }else if(name.match('鞋')){
          return 1;
        }else if(name.match('饰')){
          return 2;
        }else if(name.match('衣')){
          return 3;
        }else{
          return 0;
        }
      },
      getItem (item) {
        let backgroundImg = ''
        let useType = this.changeUseType(item);
        switch (useType) {
          case 0:
            backgroundImg = 'service_mask1'
            break
          case 1:
            backgroundImg = 'service_mask2'
            break
          case 2:
            backgroundImg = 'service_mask3'
            break
          case 3:
            backgroundImg = 'service_mask4'
            break
        }
        // 0:不能使用 1:可以使用
        if (this.activeIndex != 1) {
          backgroundImg += '.1'
        }
        return backgroundImg
      }
    }

  }
</script>

<style lang="scss" scoped>
.refundLi{
  color:#999999;
}
.lastRefund{
  color:#333333;
}
.refundBtn{
  color:#666!important;
  background: #fff!important;
}
.activecolor{
  color:#999!important;
}
.time_content{
  margin-top: 18px;
}
.bold{
  span{
    width: 100%;
    overflow: hidden;    
    text-overflow: ellipsis;      //超出部分以省略号显示
    white-space: nowrap;
  }
}
.no-list{
    width:100%;
    margin-top: 300px;
}
.top{
  position: fixed;
  top:20px;
  display: flex;
  width: 80%;
  align-items: center;
  right: 10%;
  z-index: 101;

}
.purchasedServices{
  padding: 100px 0 0;
  ul{
    li{
      height: 216px;
      padding: 20px;
      margin-bottom: -20px;
      /*border-radius:100px;*/
      background: no-repeat left top;
      background-size: 100%;
      .inner{
        width: 448px;
        padding: 25px 20px 0 242px;
        h2,div{
          display: flex;
          justify-content: space-between;
        }
        h2{
          line-height: 50px;margin-bottom: 2px;
        }
        p{
          line-height: 34px;margin-bottom: 30px;
        }
        div{
          line-height: 54px;height: 54px;
        }
      }
    }
  }
}
.containerRefond{
    padding: 30px;
    position: relative;
    padding-bottom:90px; 
    .title{
      line-height: 40px;
      margin-bottom: 50px;
      font-weight:500; 
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
    ul{
      background:url('/images/my/gun.png') no-repeat left center;
      background-size:4px 93%;

      li{
        height: 40px;
        line-height: 40px;
        margin-top: 40px;
        margin-bottom: 40px;
        padding: 0;
        padding-left:40px;
        position: relative;
        .circle{
          position: absolute;
          width: 28px;
          left: -11px;
          top:6px;
        }
        .dcircle{
          position: absolute;
          width: 28px;
          left: -11px;
          top:6px;
        }
        time{
          float: right;
        }
      }
    }
}
.containers{
    padding: 30px;
    position: relative;
    padding-bottom:90px; 
    .title{
      line-height: 40px;
      margin-bottom: 50px;
    }
    ul li{
      // width: 100%;
      height: 40px;
      margin-bottom: 30px;
      display: flex;
      align-items: center;
      span{
        margin-top:2px; 
      }
      &>div{
        margin-right: 20px;
      }
    }
    .submit{
      position: absolute;
      bottom: 30px;
      right: 30px;
    }
    .close{
      width: 36px;
      height: 36px;
      position: absolute;
      top: 30px;
      right: 30px;
      background: url("/images/public/close.png") no-repeat center;
      background-size: 32px;
    }
  }
  .bgw{
    background: #fff;
  }
  .meituan{
    padding: 4px 6px;
    border-radius: 8px;
    border: 1px solid rgb(153, 153, 153);
    color: rgb(153, 153, 153);
    display: block;
    line-height: 24px;
    height: 24px;
    margin-top: 6px;
  }

</style>
<style>
  .van-dialog__message{
    text-align: center!important;
  }
</style>

